import type { MessageContactPresentationDto } from "@multi-chat/shared";
import { conversationInitials } from "./inbox-display.js";

export function contactCardDisplayName(
  presentation: MessageContactPresentationDto,
): string | null {
  if (presentation.formattedName) {
    return presentation.formattedName;
  }
  const parts = [presentation.firstName, presentation.lastName].filter(
    (part): part is string => Boolean(part),
  );
  if (parts.length > 0) {
    return parts.join(" ");
  }
  return null;
}

export function contactCardInitials(presentation: MessageContactPresentationDto): string {
  const name = contactCardDisplayName(presentation);
  if (name) {
    return conversationInitials(name);
  }
  if (presentation.primaryPhone) {
    return conversationInitials(presentation.primaryPhone);
  }
  return "?";
}

/** CRM create prefill only. Never includes a platform profile id. */
export function sharedContactCreateDefaults(presentation: MessageContactPresentationDto): {
  firstName: string;
  lastName: string;
  displayName: string;
  email: string;
  phone: string;
} {
  const displayName =
    presentation.formattedName?.trim() ||
    [presentation.firstName, presentation.lastName].filter(Boolean).join(" ").trim();
  return {
    firstName: presentation.firstName?.trim() ?? "",
    lastName: presentation.lastName?.trim() ?? "",
    displayName,
    email: presentation.primaryEmail?.trim() ?? "",
    phone: presentation.primaryPhone?.trim() ?? "",
  };
}
